module.exports = __webpack_public_path__ + "img/logo37.f4f34a08.png";